import { render } from "./SurveyRankingtList.vue?vue&type=template&id=5ff70ece&scoped=true"
import script from "./SurveyRankingtList.vue?vue&type=script&lang=ts"
export * from "./SurveyRankingtList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5ff70ece"

export default script